import { render } from "./DragCardSubChannel.vue?vue&type=template&id=72f05692&scoped=true&ts=true"
import script from "./DragCardSubChannel.vue?vue&type=script&lang=ts"
export * from "./DragCardSubChannel.vue?vue&type=script&lang=ts"

import "./DragCardSubChannel.vue?vue&type=style&index=0&id=72f05692&lang=scss&scoped=true"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72f05692"]])

export default __exports__